import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { DocumentCopyReason, ICopiedFrom, IMergedFrom } from "../../models/Contact";
import formatDateTime from "../../utils/formatDateTime";
import StatusPill, { StatusPillColour } from "../shared/StatusPill";

// "From merged: {name}" - a lead or document a contact merge moved here. Undo it from the contact's
// Merge history.
export function MergedFromBadge({ mergedFrom }: { mergedFrom?: IMergedFrom | null }) {
  const { t } = useTranslation("accounts");

  if (!mergedFrom) return null;

  return (
    <span title={t("Merged {{date}}", { date: formatDateTime(mergedFrom.mergedAt, DateTime.DATETIME_SHORT) })}>
      <StatusPill
        colour={StatusPillColour.Purple}
        text={t("From merged: {{name}}", { name: mergedFrom.name || t("another contact") })}
      />
    </span>
  );
}

// "Copied from {name}" - a document copied onto a lead from its contact's documents. Amber when Core
// matched the seller on its own: someone's ID on a link no human checked.
export function CopiedFromBadge({ copiedFrom }: { copiedFrom?: ICopiedFrom | null }) {
  const { t } = useTranslation("accounts");

  if (!copiedFrom) return null;

  const name = copiedFrom.name || t("the contact");

  return copiedFrom.reason === DocumentCopyReason.AutoLink ? (
    <span title={t("Core matched this seller to an existing contact automatically and copied their documents. Check it is the same person.")}>
      <StatusPill colour={StatusPillColour.Orange} text={t("Copied from {{name}} (auto-matched)", { name })} />
    </span>
  ) : (
    <StatusPill colour={StatusPillColour.Neutral} text={t("Copied from {{name}}", { name })} />
  );
}
